export const STORE_KEY = '$_ebooks';
export const GET_CATS_CLASS = 'GET_CATS_CLASS';
export const GET_BOOKS = 'GET_BOOKS';
export const GET_EBOOKS = 'GET_EBOOKS';
export const GET_EBOOKS_DETAIL = 'GET_EBOOKS_DETAIL';
export const GET_EBOOKS_TYPE = 'GET_EBOOKS_TYPE';
export const GET_EBOOKS_CLASS = 'GET_EBOOKS_CLASS';
export const GET_ALL_CLASSES = 'GET_ALL_CLASSES';
export const GET_BOOK_RELATION = 'GET_BOOK_RELATION';
export const GET_BOOK_FAQ = 'GET_BOOK_FAQ';
export const GET_EBOOKS_GROUP = 'GET_EBOOKS_GROUP';




export const GET_EBOOKS_FILTER = 'GET_EBOOKS_FILTER';

export const GET_PAGE_SEARCH = 'GET_PAGE_SEARCH';
export const GET_FILTERS = 'GET_FILTERS';
export const GET_TYPE_FILTERS = 'GET_TYPE_FILTERS';



export const SET_CLASS_CURR = 'SET_CLASS_CURR';
export const FILTER_BOOKS = 'FILTER_BOOKS';
export const LOCAL_CLASS_ID = "book_class";
export const SET_CATS_BOOK = "SET_CATS_BOOK";
export const SET_BOOK = "SET_BOOK";

export const GET_EXERCISE_DETAIL = 'GET_EXERCISE_DETAIL';
export const GET_QUESTION_EXERCISE = 'GET_QUESTION_EXERCISE';
export const GET_QUESTION_EXERCISE_INFO = 'GET_QUESTION_EXERCISE_INFO';

export const TYPE_RADIO = 'radio';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_TRUE_FALSE_NO = 'answer_t_f_no';
export const TYPE_MATH_COL = 'math_col';
export const TYPE_FILL_BLANK = 'fill_blank';
export const TYPE_FILL_SENTENCE = 'fill_sentence';
export const TYPE_SELECT = 'select';
export const TYPE_DOWN_ANSWER = 'down_answer';
export const TYPE_CIRCLE_ANSWER = 'circle_answer';
export const TYPE_X_MARK = 'x_mark_answer';
export const TYPE_GROUP = 'group';

export const OPEN_MATH_FORM = "EMIT_OPEN_MATH_FORM";
export const SEND_MATH_VAL = "EMIT_SEND_MATH_VAL";
export const VALIDATE_QUESTION = "VALIDATE_QUESTION";
export const SET_QUESTION_ACTIVITY = "SET_QUESTION_ACTIVITY";
export const CHECK_CORRECT_QUESTION = "CHECK_CORRECT_QUESTION";
export const SET_QUESTION_VALID_DATA = "SET_QUESTION_VALID_DATA";
export const LOCAL_SAVE_PAGE_OPEN = "page_open";
export const LOCAL_SAVE_BOOK_TYPE = "book_type";
export const LOCAL_SAVE_TAB_LISTPAGE = "tabbook";
export const SET_PARAM_SEARCH_RELATE_MEDIA = "SET_PARAM_SEARCH_RELATE_MEDIA";
export const SET_RELATE_MEDIA_VIEWER = "SET_RELATE_MEDIA_VIEWER";
export const GET_TRAINING_ID = "GET_TRAINING_ID";

export const ID_MODAL_ACTIVE_BOOK = "modal_book_active";
export const EBOOK_SET_QUESTION_WORKING = 'EBOOK_SET_QUESTION_WORKING';
export const EBOOK_SET_MEDIA_VIEWING = 'EBOOK_SET_MEDIA_VIEWING';
export const EBOOK_SET_LESSON_VIEWING = 'EBOOK_SET_LESSON_VIEWING';
export const ID_MODAL_EBOOK_LESSON_INFO = 'modal_ebook_lesson_info';
export const ID_MODAL_DESC_DEACTIVE_BOOK = 'modal_deactive_book';
export const ID_MODAL_CONFIRM_DEACTIVE_BOOK = 'modal_confirm_deactive_book'
export const SET_DATA_DEACTIVE_BOOK = 'SET_DATA_DEACTIVE_BOOK'
export const SET_ID_BOOK_DEACTIVE_DONE = 'SET_ID_BOOK_DEACTIVE_DONE'
